import * as React from 'react';
import Box from '@mui/material/Box';
import { Alert, Button, Chip, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import $ from "jquery";
import Common from '../utilities/common';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import NormalizeProgressItem from './NormalizeProgressItem';
import { NormalizationProgressItem } from '../models/NormalizationItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntityPermissions from '../components/EntityPermissions';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import EntitySettings from '../components/EntitySettings';
import FeatureManager from '../components/Utilities/FeatureManager';

export interface INormalizeProgressState {
    data: any[];
    selectedTab: string;
    loading: boolean;
    totalPendiente: number;
    totalActivo: number;
    totalError: number;
    totalFinalizado: number;
    totalConsolidada: number;
    openPermissionsDialog: boolean;
}


export default class NormalizeProgress extends React.Component<{}, INormalizeProgressState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedTab: 'pendiente',
            loading: true,
            totalPendiente: 0,
            totalActivo: 0,
            totalError: 0,
            totalFinalizado: 0,
            totalConsolidada: 0,
            openPermissionsDialog: false
        };
    }

    componentDidMount(): void {
        this.GetData('pendiente');
    }

    public render(): React.ReactElement<{}> {
        return (
            <div>
                <Box className='stepper'>
                    <Grid container>
                        <Grid item xs={1}>
                            <Typography>
                                <SettingsSuggestOutlinedIcon className='mainIcon'/>
                            </Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography className='mainTitle'>
                            Normalizaciones
                            </Typography>
                        </Grid>
                        <Grid item xs={2} className='entitySettings'>
                            <EntitySettings entity={Entity.Normalizaciones}/>
                        </Grid>
                    </Grid>
                </Box>
                <Box className='main'>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={this.state.selectedTab} onChange={(event: React.SyntheticEvent, newValue: string) => {
                            this.setState({
                                loading: true,
                                selectedTab: newValue
                            });

                            this.GetData(newValue);
                        }}>
                            <Tab label={
                                <Typography variant='body2' component={'div'}>
                                    Pendiente
                                    <Chip label={this.state.totalPendiente} style={{marginLeft: '5px'}}/>
                                </Typography>
                            } value='pendiente'/>
                            <Tab label={
                                <Typography variant='body2' component={'div'}>
                                    Activo
                                    <Chip label={this.state.totalActivo}  style={{marginLeft: '5px'}}/>
                                </Typography>
                            } value='activo'/>
                            <Tab label={
                                <Typography variant='body2' component={'div'}>
                                    Finalizado
                                    <Chip label={this.state.totalFinalizado}  style={{marginLeft: '5px'}}/>
                                </Typography>
                            } value='finalizado'/>
                            <Tab label={
                                <Typography variant='body2' component={'div'}>
                                    Error
                                    <Chip label={this.state.totalError}  style={{marginLeft: '5px'}}/>
                                </Typography>
                            } value='error'/>
                            <Tab label={
                                <Typography variant='body2' component={'div'}>
                                    Consolidada
                                    <Chip label={this.state.totalConsolidada} style={{marginLeft: '5px'}}/>
                                </Typography>
                            } value='consolidada'/>
                        </Tabs>
                    </Box>
                    {
                        this.state.loading && (
                            <div style={{textAlign: 'center', marginTop: '40px'}}>
                                <CircularProgress />
                            </div>
                        )
                    }
                    {
                        !this.state.loading && this.state.data.map((item: any, index: number) => {
                            return (
                                <NormalizeProgressItem key={index} item={item}/>
                            )
                        })
                    }
                    {
                        !this.state.loading && this.state.data.length == 0 && (
                            <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                        )
                    }
                </Box>
                <FeatureManager entidad={Entity.Normalizaciones} operacion='Crear'>
                    <Box className='stepper' sx={{textAlign: 'right'}}>
                        <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Crear}>
                            <Button variant="contained" onClick={() => {
                                window.location.href = '/new'
                            }}>
                                Nueva normalización
                            </Button>
                        </SecurityTrimmer>
                    </Box>
                </FeatureManager>
            </div>
        )
    }

    private GetData(status: string): void {
        let url = `${Common.END_POINT}/normalizations/${status}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: NormalizationProgressItem[]) => {
            this.setState(
                {
                    data: response,
                    loading: false
                }
            );

            this.GetTotalActivo();
            this.GetTotalPendiente();
            this.GetTotalFinalizado();
            this.GetTotalError();
            this.GetTotalConsolidada();
        })
    }

    private GetTotalPendiente() {
        let url = `${Common.END_POINT}/normalizaciones/status/pendiente`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalPendiente: response
                }
            );
        })
    }

    private GetTotalActivo() {
        let url = `${Common.END_POINT}/normalizaciones/status/activo`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalActivo: response
                }
            );
        })
    }

    private GetTotalError() {
        let url = `${Common.END_POINT}/normalizaciones/status/error`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalError: response
                }
            );
        })
    }

    private GetTotalConsolidada() {
        let url = `${Common.END_POINT}/normalizaciones/status/consolidada`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalConsolidada: response
                }
            );
        })
    }

    private GetTotalFinalizado() {
        let url = `${Common.END_POINT}/normalizaciones/status/finalizado`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalFinalizado: response
                }
            );
        })
    }
}